import React from 'react';

interface SkeletonProps {
  width?: string;
  height?: string;
  borderRadius?: string;
  count?: number;
  style?: React.CSSProperties;
}

const Skeleton: React.FC<SkeletonProps> = ({
  width = '100%',
  height = '16px',
  borderRadius = '4px',
  count = 1,
  style,
}) => (
  <>
    {Array.from({ length: count }).map((_, i) => (
      <div
        key={i}
        className="skeleton-pulse"
        style={{
          width,
          height,
          borderRadius,
          marginBottom: count > 1 ? '8px' : 0,
          ...style,
        }}
      />
    ))}
  </>
);

export const SkeletonTable: React.FC<{ rows?: number; cols?: number }> = ({
  rows = 5,
  cols = 6,
}) => (
  <div className="data-table-wrapper">
    <table className="data-table">
      <thead>
        <tr>
          {Array.from({ length: cols }).map((_, i) => (
            <th key={i}>
              <Skeleton width="80%" height="14px" />
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {Array.from({ length: rows }).map((_, ri) => (
          <tr key={ri}>
            {Array.from({ length: cols }).map((_, ci) => (
              <td key={ci}>
                <Skeleton width={`${60 + Math.random() * 30}%`} height="14px" />
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

export const SkeletonCard: React.FC = () => (
  <div className="card">
    <div className="card-header">
      <Skeleton width="200px" height="20px" />
    </div>
    <div className="card-body">
      <Skeleton count={4} />
    </div>
  </div>
);

export const SkeletonStats: React.FC<{ count?: number }> = ({ count = 6 }) => (
  <div className="stats-grid">
    {Array.from({ length: count }).map((_, i) => (
      <div key={i} className="stat-card">
        <div className="stat-icon blue">
          <Skeleton width="24px" height="24px" borderRadius="50%" />
        </div>
        <div className="stat-info" style={{ gap: '6px' }}>
          <Skeleton width="60px" height="24px" />
          <Skeleton width="90px" height="12px" />
        </div>
      </div>
    ))}
  </div>
);

export default Skeleton;
